import React from "react";
import PropTypes from "prop-types";

import { ColorPicker, FileInput, GradientInput, NumberInput } from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const Page = () => {
	const fields = [
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<NumberInput
			field="paddingVertical"
			id="paddingVertical"
			placeholder="Vertical Padding"
			min={0}
			max={768}
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingHorizontal"
			id="paddingHorizontal"
			placeholder="Horizontal Padding"
			min={0}
			max={768}
			themeBuilderInputType="NumberInput"
		/>,
	];
	return (
		<div className="theme-columns">
			<div className="theme-column">
				<h4 className="header">Page</h4>
				<div className="theme-content">{renderFields(fields)}</div>
			</div>
		</div>
	);
};

Page.propTypes = {
	themeData: PropTypes.object,
};

export default Page;
